export const CourseInstanceOverview = (props: {
  courseInstanceId: string | undefined
}) => {
  return null
}
